import { Link } from "react-router-dom";
import { categories, friendLinks, seoKeywordCloud } from "@/mocks/site";

const sitemapGroups = [
  {
    title: "热门频道",
    links: categories.slice(0, 4).map((item) => ({ label: item.label, to: `/category?type=${item.key}` })),
  },
  {
    title: "精选频道",
    links: categories.slice(4).map((item) => ({ label: item.label, to: `/category?type=${item.key}` })),
  },
  {
    title: "追剧服务",
    links: [
      { label: "播放历史", to: "/history" },
      { label: "全部剧集", to: "/category" },
      { label: "本周热播榜", to: "/category?sort=hot" },
      { label: "高分完结精选", to: "/category?status=done&sort=rating" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-foreground-50/10 bg-background-950 md:mt-24">
      <div className="w-full px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <section aria-labelledby="footer-brand">
            <h2 id="footer-brand" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-primary-300 to-accent-600 text-background-950">
                <i className="ri-movie-2-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-black text-foreground-50">剧焰短剧</span>
            </h2>
            <p className="mt-3 max-w-md text-xs leading-relaxed text-foreground-500 md:text-sm">
              剧焰短剧是一个专注微短剧内容聚合的在线追剧站，收录霸道总裁、都市战神、战神归来、甜宠虐恋、穿越复仇、古装权谋等热门题材，每日更新最新剧集与播放榜单，支持手机与电脑高清观看。
            </p>
          </section>

          {sitemapGroups.map((group) => (
            <nav key={group.title} aria-label={`${group.title}导航`}>
              <h2 className="mb-3 font-heading text-sm font-bold text-foreground-100">{group.title}</h2>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      className="cursor-pointer text-xs text-foreground-500 transition-colors hover:text-primary-300 md:text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        {/* 友情链接 */}
        <section aria-labelledby="footer-friends" className="mt-10 border-t border-foreground-50/10 pt-7">
          <h2 id="footer-friends" className="mb-3 text-xs font-semibold tracking-wide text-foreground-400">
            友情链接
          </h2>
          <ul className="flex flex-wrap gap-x-5 gap-y-2">
            {friendLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  rel="noopener"
                  className="cursor-pointer text-xs text-foreground-500 transition-colors hover:text-primary-300"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </section>

        {/* SEO 长尾词文本块 */}
        <section aria-labelledby="footer-seo" className="mt-8 rounded-xl border border-foreground-50/[0.07] bg-foreground-50/[0.02] p-4 md:p-5">
          <h2 id="footer-seo" className="mb-2 font-heading text-sm font-bold text-foreground-200">
            关于剧焰短剧 · 微短剧在线观看指南
          </h2>
          <p className="text-[11px] leading-relaxed text-foreground-500 md:text-xs">
            剧焰短剧提供最新热门微短剧在线观看服务，涵盖短剧排行榜、分集剧情介绍、演员阵容与主题标签。你可以按类型、地区、年份、连载状态与评分筛选想看的剧集，也可以直接搜索剧名快速进入播放页。站内所有剧集均提供高清画质与选集功能，支持断点续播与播放历史记录。
          </p>
          <p className="mt-2 flex flex-wrap gap-x-2 gap-y-1 text-[11px] leading-relaxed text-foreground-600 md:text-xs">
            {seoKeywordCloud.map((word) => (
              <span key={word} className="text-foreground-600">
                {word}
                <span className="ml-2 text-foreground-800">/</span>
              </span>
            ))}
          </p>
        </section>

        <div className="mt-8 flex flex-col gap-2 border-t border-foreground-50/10 pt-6 text-[11px] text-foreground-600 md:flex-row md:items-center md:justify-between md:text-xs">
          <p>© 2026 剧焰短剧 JUYAN DRAMA. 本站内容均为演示数据，仅供界面展示使用。</p>
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <Link to="/category" className="cursor-pointer transition-colors hover:text-primary-300">
              站点地图
            </Link>
            <span className="text-foreground-800">|</span>
            <span>内容索引：{categories.length} 个频道 · 每日更新</span>
          </p>
        </div>
      </div>
    </footer>
  );
}